export default __webpack_public_path__ + "static/media/Affiliate_program.56a08082.webp";